// enquiry-module-v1/MasterPages/LeadSourceMaster.jsx

import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Box, Paper, Typography, TextField, Grid, Button, } from '@mui/material';

export default function LeadSourceMaster({
    mode,
    onPopupCancel,
    loggedInUser,
    companyData,
    connectionString
}) {
    const { id } = useParams();
    const navigate = useNavigate();

    // Use props instead of context
    const companyId = companyData?.companyId;
    const fYear = companyData?.financialYear;
    const username = loggedInUser?.emailId;

    const [leadSource, setLeadSource] = useState('');

    // Load existing data when in edit mode
    useEffect(() => {
        if (mode === 'edit' && id) {
            axios
                .get(`${connectionString}/leadSource/getDetails/${id}`)
                .then(res => setLeadSource(res.data.LeadSource || ''))
                .catch(err => console.error('Error fetching LeadSource:', err));
        }
    }, [mode, id]);

    const handleCancel = () => {
        if (onPopupCancel) {
            onPopupCancel();
        } else {
            navigate('/main/leadSourceDetail');
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const payload = { LeadSource: leadSource, companyId, fYear, username };

        try {
            if (mode === 'add') {
                await axios.post(`${connectionString}/leadSource/Insert`, payload);
                alert('Lead Source added successfully');
                setLeadSource('');
            } else {
                await axios.put(
                    `${connectionString}/leadSource/Update/${id}`,
                    payload
                );
                alert('Lead Source updated successfully');
            }
            // close popup or navigate away
            handleCancel();
        } catch (err) {
            console.error('Error saving Lead Source:', err);
            alert(`Failed to ${mode === 'add' ? 'add' : 'update'} Lead Source`);
        }
    };

    return (
        <Paper elevation={3} sx={{ maxWidth: 600, mx: 'auto', p: 4 }}>
            <Typography variant="h5" gutterBottom>
                {mode === 'add' ? 'Add New Lead Source' : 'Edit Lead Source'}
            </Typography>

            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 2 }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label="Lead Source"
                            required
                            fullWidth
                            size="small"
                            value={leadSource}
                            onChange={e => setLeadSource(e.target.value)}
                        />
                    </Grid>

                    <Grid item xs={12} container justifyContent="center" spacing={2}>
                        <Grid item>
                            <Button type="submit" variant="contained" color="primary">
                                {mode === 'add' ? 'Save' : 'Update'}
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="outlined" onClick={handleCancel}>
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>
        </Paper>
    );
}